/**
 * Who the Picture-in-Picture window shows beside the user's own tile.
 *
 * The last OTHER person who spoke, held until someone else speaks. The
 * meeting's `activeSpeakerId` is already sticky through silence, but it moves
 * to the user when they talk — taking it as-is emptied the second tile the
 * moment the user answered the person they were listening to. Dropped when
 * that person leaves; the tile then waits for the next speaker, rather than
 * falling back to anyone in particular.
 */
export interface PipSpeakerCandidate {
  id: string
  isLocal?: boolean
  /** `'additional'` is a second stream of a participant, never a speaker tile. */
  sourceKind?: string
}

export function nextPipSpeaker(
  current: string | null,
  activeSpeakerId: string | null | undefined,
  participants: readonly PipSpeakerCandidate[],
): string | null {
  const stillHere = current !== null && participants.some((p) => p.id === current)
  let next = stillHere ? current : null
  if (activeSpeakerId) {
    const speaker = participants.find((p) => p.id === activeSpeakerId)
    if (speaker && !speaker.isLocal && speaker.sourceKind !== 'additional') next = speaker.id
  }
  return next
}
